import Swiper, { Scrollbar } from "swiper";
class ImageTextColumn extends HTMLElement {
  constructor() {
    super();

    this.imageTextSlider = this.querySelector(".text-column");
    const md = window.matchMedia("(max-width: 767px)");

    let offset = 0;
    if (md.matches) {
      offset = 20;
    } else {
      offset = 80;
    }

    const textColumnSlider = new Swiper(this.imageTextSlider, {
      modules: [Scrollbar],
      spaceBetween: 20,
      slidesPerView: "auto",
      slidesOffsetBefore: offset,
      autoHeight: false,
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
    });
  }
}

customElements.define("image-text-column", ImageTextColumn);
